module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/47.74494ebb.png";